import Enterprise from '@/types/enterprise';
import EnterpriseAdminDetails from '@/types/enterprise-admin-details';
import EnterpriseGroup from '@/types/enterprise-group';
import AppMode from '@/types/app-mode';
import AppRegion from '@/types/app-region';

export const ENTERPRISE_FEATURES = {
  USER_MANAGEMENT: 'userManagement',
  PORTFOLIOS: 'portfolios',
};

// The enterprise group is the one that includes all members of the enterprise - think of it as the master registry of users
export const ENTERPRISE_GROUP_NAME = 'Enterprise';

/**
 * Checks if the group is the main Enterprise group
 * @param {EnterpriseGroup} group the group to check
 */
export const isEnterpriseGroup = (group: EnterpriseGroup) => group.name === ENTERPRISE_GROUP_NAME;

export const getGroup = (enterprise: Enterprise, groupName: string = ENTERPRISE_GROUP_NAME): EnterpriseGroup | undefined =>
  enterprise.groups.find(g => g.name === groupName);

export const getEnterpriseGroup = (enterprise: EnterpriseAdminDetails): EnterpriseGroup => {
  // always the first one
  if (enterprise && enterprise.groups.length > 0) {
    return enterprise.groups[0];
  }

  return {
    _id: '',
    members: [],
    features: [],
    portfolios: [],
    name: '',
  };
};

/**
 * Checks if the group mode is the expected mode
 * @param {AppMode} mode the group mode to check
 * @param {AppMode} expectedMode the group mode to compare
 */
export const validateAppMode = (mode: AppMode, expectedMode: AppMode) => mode === expectedMode;

/**
 * Checks if the group region is the expected region
 * @param {AppRegion} region the group region to check
 * @param {AppRegion} expectedRegion the group region to compare
 */
export const validateAppRegion = (region: AppRegion, expectedRegion: AppRegion) => region === expectedRegion;
